//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/DebugSession.js";
let d=[[],[[["itemId","revisionId","itemType","itemName","folderPath","folderName","kfPartSpec","drawingPartSpecs","drawingBookletItemId","drawingBookletItemRevId"],"CreateNew",{},8,0],[["drawingPartSpec","revRuleName","drawingBookletItemId","drawingBookletItemRevId"],"LoadFromDrawingPart",{},2,0],[["drawingBookletItemId","drawingBookletItemRevId","revRuleName"],"Load",{},3,0],[["drawingBookletItemId","drawingBookletItemRevId","revRuleName"],"Reload",{},3,0],[["drawingBookletItemIdIn","drawingBookletItemRevIdIn","drawingBookletItemIdOut","drawingBookletItemRevIdOut"],"Save",{},2,0],[["drawingBookletItemId","drawingBookletItemRevId","drawingPartSpecs"],"AddDrawingReferences",{},3,0],[["drawingBookletItemId","drawingBookletItemRevId","drawingPartSpecs"],"RemoveDrawingReferences",{},3,0],[["drawingBookletItemId","drawingBookletItemRevId"],"RemoveAllDrawingReferences",{},2,0],[["drawingBookletItemId","drawingBookletItemRevId","drawingPartSpecs"],"ReviseDrawingReferences",{},3,0],[[],"ClearCache",{},0,0]],[]];
SPLM.TCINDrawingBooklet = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.TCINDrawingBooklet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;